<div class="card">
  <div class="card-title">
    <h2>Prospect Activity Summary</h2>
  </div>
  <div class="prospect-summary-container">
    <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
      <p-accordionTab header="Prospect Activity Summary Table">
        <div class="group-cont">
          <div class="table-responsive">
            <p-table #dtProspectActivitySummary class="table" styleClass="ui-table-products" tableStyleClass="table table-responsive"
              [value]="prospectActivitySummary" totalRecords="{{prospectActivitySummary.length}}" [rows]="10" [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10, 25, 50]" [paginator]="true" [resizableColumns]="true"
              (onFilter)="onActivityTableFilter($event)"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
              <ng-template pTemplate="caption">
                <div style="text-align: right">
                  <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                    (click)="exportProspectActivityExcel()" style="margin-top: 0.5em;margin-right: 0.5em;"
                    class="ui-button-success"></button>
                  <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" style="margin-top: 0.5em;"
                    (click)="exportProspectActivityPdf()" label="PDF" class="ui-button-warning"></button>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th>#</th>
                  <th pSortableColumn="technician" width="30%">Technical Lead
                    <p-sortIcon field="technician"></p-sortIcon>
                  </th>
                  <th pSortableColumn="customerName" width="30%">Customer Name
                    <p-sortIcon field="customerName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="prospectLeaderCount" width="20%">Prospect Count
                    <p-sortIcon field="prospectLeaderCount"></p-sortIcon>
                  </th>
                  <th pSortableColumn="activityAttendedCount" width="20%">Activity Count
                    <p-sortIcon field="activityAttendedCount"></p-sortIcon>
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th>
                    <p-columnFilter
                      field="technician"
                      matchMode="in"
                      display="menu"
                      [showMatchModes]="false"
                      [showOperator]="false"
                      [showAddButton]="false"
                      [showMenu]="true">
                      
                      <ng-template pTemplate="filter" let-filter="filterCallback">
                        <p-multiSelect
                          [options]="technicianOptions"
                          placeholder="Select Technical Lead(s)"
                          (onChange)="filter($event.value)"
                          optionLabel="label"
                          optionValue="value"
                          display="chip"
                          [filter]="true">
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter field="customerName" type="text" display="menu"
                      placeholder="Customer Name"></p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter field="prospectLeaderCount" type="numeric" display="menu"
                      placeholder="Prospect Count"></p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter field="activityAttendedCount" type="numeric" display="menu"
                      placeholder="Activity Count"></p-columnFilter>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-activity let-i="rowIndex">
                <tr>
                  <td>{{i + 1}}</td>
                  <td>{{activity.technician}}</td>
                  <td>{{activity.customerName}}</td>
                  <td>{{activity.prospectLeaderCount}}</td>
                  <td>{{activity.activityAttendedCount}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div class="card">
    <div class="card-title">
      <h2>Prospect Activity Summary Chart</h2>
    </div>
    <div class="cont" id="activity-chart-Container">
      <div class="p-grid"
        style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <div class="p-col-6" style="flex: 1; padding: 0 5px;">
          <label for="activityGroupBy">Group By:</label>
          <p-dropdown id="activityGroupBy" [options]="activityGroupByOptions" [(ngModel)]="selectedActivityGroupBy"
            (onChange)="onActivityGroupByChange()" optionLabel="label" optionValue="value">
          </p-dropdown>
        </div>
        <div class="p-col-6" style="flex: 1; padding: 0 5px;">
          <label for="countType">Data Type:</label>
          <p-dropdown id="countType" [options]="countTypeOptions" [(ngModel)]="selectedCountType"
            (onChange)="onCountTypeChange()" optionLabel="label" optionValue="value">
          </p-dropdown>
        </div>
      </div>
      <p-chart #prospectActivityChart type="bar" [data]="prospectActivityChartData" [options]="prospectActivityChartOptions"
        height="380px"></p-chart>
      <button type="button" (click)="exportProspectActivityChartAsImage()" class="ui-button-success export-button"
        style="margin-top: 1em;">Export Chart as PNG</button>
      <button type="button" (click)="exportProspectActivityChartAsPDF()" class="ui-button-success export-button"
        style="margin-top: 1em;">Export Chart as PDF</button>
    </div>
  </div>
</div>
